import * as React from 'react';
import SearchFilters from '../SearchFilters/SearchFilters';
import * as Styled from './styled';
import ViewGroupsButton from './ViewGroupsButton/ViewGroupsButton';

const SearchLinks: React.FunctionComponent = props => {
	return (
		<Styled.Ul>
			<Styled.Li>
				<SearchFilters theme="light" />
			</Styled.Li>
			<Styled.Li>
				<ViewGroupsButton theme="light" />
			</Styled.Li>
		</Styled.Ul>
	);
};

export default SearchLinks;
